import { Stack, Typography } from "@mui/material";
import * as React from "react";
import { FormattedMessage } from "../utils/FormattedMessage";
import { TitleDivider } from "../common/TitleDivider";

function Intro() {
  return (
    <Stack
      sx={{
        maxWidth: 1000,
        mx: "auto",
        px: {
          xs: 2,
          md: 4,
          lg: 6,
        },
        textAlign: "center",
      }}
    >
      <Typography variant="h2" color="secondary">
        <FormattedMessage id="contacts.welcome.title" />
        <TitleDivider />
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mt: {
            xs: 2,
            md: 4,
            lg: 5,
          },
        }}
      >
        <FormattedMessage id="contacts.welcome.body" />
      </Typography>
    </Stack>
  );
}

export { Intro };
